// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2LRI1","label":"LabeledBox_label__3oyt5"};